import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeUrl} from '@angular/platform-browser';

@Pipe({
  name: 'keepHtml',
  standalone: true
})
export class KeepHtmlPipe implements PipeTransform {

  constructor(protected sourceSanitizer: DomSanitizer) {}

  transform(value: string, type: string): SafeHtml | SafeScript | SafeUrl | SafeResourceUrl | string | null {
    switch (type) {
      case 'style':
        return this.sourceSanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this.sourceSanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this.sourceSanitizer.bypassSecurityTrustUrl(value);
      case 'resource-url':
        return this.sourceSanitizer.bypassSecurityTrustResourceUrl(value);
      case 'html':
        return this.sourceSanitizer.bypassSecurityTrustHtml(value);
      default:
        return this.sourceSanitizer.sanitize(SecurityContext.NONE, value);
    }
  }
}
